<template>
	<header>
		<Cabecalho />
	</header>
	<router-view />
</template>

<script>
import { defineComponent } from 'vue'
import Cabecalho from '@/components/Cabecalho.vue'

export default defineComponent({
	name: 'App',
	components: {
		Cabecalho
	}
})

</script>
<style>
html {
	scrollbar-width: none;
}
</style>
